'use client';
/** @jsxImportSource @emotion/react */

import React, { memo, useCallback } from 'react';

import { Box } from '../../box/Box';
import { styled } from '../../styled/styled';
import { clamp } from '../utils/clamp';

const StyledHistogram = styled(Box)(({ theme }) => ({
  alignItems: 'flex-end',
  display: 'grid',
  gap: '1px',
  gridAutoFlow: 'column',
  height: theme.spacing(11),
  position: 'relative',
  transform: 'translateY(12px)', // 12px = track paddding
  width: '100%',
}));

const StyledHistogramBar = styled(Box)(() => ({
  backgroundColor: '#ededed', // TODO: Refactor to use a Design Token value
}));

export interface HistogramProps {
  bars: number[];
}

export const Histogram = memo(({ bars }: HistogramProps) => {
  const hasData = !!bars.length;
  const calculateBarHeight = useCallback(
    (bar: number) => clamp(bar, 0, 1) * 100,
    []
  );

  return hasData ? (
    <StyledHistogram role="presentation">
      {bars.map((bar, index) => (
        <StyledHistogramBar
          key={index}
          sx={{ height: `${calculateBarHeight(bar)}%` }}
        ></StyledHistogramBar>
      ))}
    </StyledHistogram>
  ) : null;
});
